import React, { useEffect, useState } from 'react';
import { Descriptions, Spin, Typography } from 'antd';
import {
  getPhysicalAttributes,
  PhysicalAttributes,
} from 'services/PhysicalAttributesService';

const { Text } = Typography;

const EMPTY = '—';

const measure = (value?: number, unit?: string): string =>
  value ? `${value} ${unit ?? ''}`.trim() : EMPTY;

interface Props {
  shipmentId?: number;
  packageQuantity?: number;
}

const MeasuresView = ({ shipmentId, packageQuantity }: Props) => {
  const [loading, setLoading] = useState(true);
  const [attributes, setAttributes] = useState<PhysicalAttributes | null>(null);

  useEffect(() => {
    let active = true;
    if (!shipmentId) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    getPhysicalAttributes(shipmentId).then((data) => {
      if (!active) return;
      setAttributes(data);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [shipmentId]);

  const weight = attributes?.weight;
  const dimensions = attributes?.dimensions;
  const hasMeasures = Boolean(weight?.value || dimensions);

  return (
    <Spin spinning={loading}>
      <Descriptions column={{ xs: 1, sm: 2, lg: 4 }} size="small">
        <Descriptions.Item label="Cantidad de bultos">
          {packageQuantity ?? 1}
        </Descriptions.Item>
        <Descriptions.Item label="Peso">
          {measure(weight?.value, weight?.unit)}
        </Descriptions.Item>
        <Descriptions.Item label="Alto">
          {measure(dimensions?.height, dimensions?.unit)}
        </Descriptions.Item>
        <Descriptions.Item label="Ancho">
          {measure(dimensions?.width, dimensions?.unit)}
        </Descriptions.Item>
        <Descriptions.Item label="Profundidad">
          {measure(dimensions?.length, dimensions?.unit)}
        </Descriptions.Item>
      </Descriptions>
      {!loading && !hasMeasures && (
        <Text type="secondary">
          Este envío no tiene peso ni medidas cargados.
        </Text>
      )}
    </Spin>
  );
};

export default MeasuresView;
